module.exports = __webpack_public_path__ + "static/media/feature9.21beff4f.png";